export default __webpack_public_path__ + "static/media/2006.f227a9b7.jpg";